// Chrome 內建翻譯或翻譯類外掛會把 React 管理的文字節點包進 <font> 等元素,
// React 之後卸載該區塊(例如 Radix Select 的 portal)時,removeChild /
// insertBefore 找不到原節點就丟出 NotFoundError,整個 React tree 被
// ErrorBoundary 打掉(Sentry ADMIN-A)。React 官方沒有修這個問題,
// 建議做法即是此防禦性 patch,參考 facebook/react#11538。
export function installDomSafetyGuards(nodeCtor: typeof Node | undefined = globalThis.Node) {
  if (typeof nodeCtor !== 'function' || !nodeCtor.prototype) return

  const originalRemoveChild = nodeCtor.prototype.removeChild
  nodeCtor.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) {
      // 節點已被外部程式(翻譯外掛等)搬走,略過移除避免整頁崩潰
      console.warn('removeChild: node has been moved by an external script, skipping', child)
      return child
    }
    return originalRemoveChild.call(this, child) as T
  }

  const originalInsertBefore = nodeCtor.prototype.insertBefore
  nodeCtor.prototype.insertBefore = function <T extends Node>(
    this: Node,
    newNode: T,
    referenceNode: Node | null,
  ): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      // 參考節點已被搬走,退而附加到末端,至少保住新節點的內容
      console.warn(
        'insertBefore: reference node has been moved by an external script, appending instead',
        referenceNode,
      )
      return originalInsertBefore.call(this, newNode, null) as T
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T
  }
}
